import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {useFileDownload} from 'hooks/api/useFileDownload'

export const useDownloadNoticeFile = () => {
  const authAxios = useAuthAxios()
  const {download} = useFileDownload()

  return async (egovProcedureId: string, noticeId: string) => {
    const path = `/api/egov/v1/egov_procedures/${egovProcedureId}/notice_file/${noticeId}`
    const getter = () => authAxios.get(path, {responseType: 'arraybuffer'})

    download(getter)
  }
}
